import type { DoraFinancialEntity } from './doraFinancialEntity.ts';
import type { DoraICTThirdPartyProvider } from './doraICTThirdPartyProvider.ts';
import type { DoraBusinessService } from './doraBusinessService.ts';
import type { DoraRisk } from './doraRisk.ts';
import type { DoraIncident } from './doraIncident.ts';
import type { DoraTestingExercise } from './doraTestingExercise.ts';
import { isNumber } from './utils.ts';

export interface DoraICTService {
  id?: number;
  name: string;
  description?: string | null;
  is_external: boolean;
  financial_entity_id: number;
  third_party_provider_id?: number | null;
  financial_entity?: DoraFinancialEntity;
  third_party_provider?: DoraICTThirdPartyProvider | null;
  business_services?: DoraBusinessService[];
  risks?: DoraRisk[];
  incidents?: DoraIncident[];
  tests?: DoraTestingExercise[];
}

export type DoraICTServiceUpdate = Partial<Omit<DoraICTService,
  'id' |
  'financial_entity' |
  'third_party_provider' |
  'business_services' |
  'risks' |
  'incidents' |
  'tests'
>> & {
  business_service_ids?: number[];
};

export const doraICTServiceToUpdate = ({
  id,
  financial_entity,
  third_party_provider,
  business_services,
  risks,
  incidents,
  tests,
  ...rest
}: DoraICTService): DoraICTServiceUpdate => ({
  ...rest,
  business_service_ids: business_services
    ?.map(service => service.id)
    .filter(isNumber),
});
